import ImageGallery from 'LuxKit/Carousel/ImageGallery'
import React, { ComponentProps } from 'react'

type InheritedImageGalleryProps = Pick<ComponentProps<typeof ImageGallery>, 'onImageChange' | 'topRight' | 'imageParams' | 'className'>

interface Props extends InheritedImageGalleryProps {
  room: App.PackageRoomType | App.BedbankPackage
}

function OfferPageRoomGallery(props: Props) {
  const {
    room,
    ...rest
  } = props

  if (!room.images) return null

  return <ImageGallery
    {...rest}
    images={room.images}
    size="small"
    showImageTitles={false}
  />
}

export default OfferPageRoomGallery
